import { render, staticRenderFns } from "./CustomOfficialEvents.vue?vue&type=template&id=d2f789dc&scoped=true"
import script from "./CustomOfficialEvents.vue?vue&type=script&lang=js"
export * from "./CustomOfficialEvents.vue?vue&type=script&lang=js"
import style0 from "./CustomOfficialEvents.vue?vue&type=style&index=0&id=d2f789dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f789dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f789dc')) {
      api.createRecord('d2f789dc', component.options)
    } else {
      api.reload('d2f789dc', component.options)
    }
    module.hot.accept("./CustomOfficialEvents.vue?vue&type=template&id=d2f789dc&scoped=true", function () {
      api.rerender('d2f789dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/CustomOfficialEvents.vue"
export default component.exports